import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export const AnimatedVideo: React.FC = () => {
  const [currentScene, setCurrentScene] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        startAnimation();
      }
    }, {
      threshold: 0.3
    });
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);
  const startAnimation = async () => {
    const scenes = [0, 1, 2, 3, 4, 5];
    for (const scene of scenes) {
      setCurrentScene(scene);
      await new Promise(resolve => setTimeout(resolve, 2500));
    }
    // Loop back to start
    setCurrentScene(0);
  };
  const scenes = [{
    id: 0,
    content: <div className="flex flex-col items-center" data-id="element-20">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-21">
            <circle cx="12" cy="8" r="4" stroke="white" strokeWidth="1.5" data-id="element-22" />
            <path d="M5 18C5 15.7909 7.01472 14 9.5 14H14.5C16.9853 14 19 15.7909 19 18" stroke="white" strokeWidth="1.5" data-id="element-23" />
            <path d="M8 10L10 12L8 14" stroke="#E11D48" strokeWidth="2" strokeLinecap="round" data-id="element-24" />
            <path d="M16 10L14 12L16 14" stroke="#E11D48" strokeWidth="2" strokeLinecap="round" data-id="element-25" />
          </svg>
          <p className="text-2xl font-bold mt-6 text-center" data-id="element-26">
            A stressed business owner surrounded by bills
          </p>
        </div>
  }, {
    id: 1,
    content: <div className="text-center" data-id="element-27">
          <p className="text-3xl font-bold text-red-600 mb-4" data-id="element-28">
            Company drowning in debt?
          </p>
          <svg width="100" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto" data-id="element-29">
            <path d="M12 2L12 22" stroke="#E11D48" strokeWidth="2" strokeLinecap="round" data-id="element-30" />
            <path d="M2 12L22 12" stroke="#E11D48" strokeWidth="2" strokeLinecap="round" data-id="element-31" />
            <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="1.5" data-id="element-32" />
          </svg>
        </div>
  }, {
    id: 2,
    content: <div className="text-center" data-id="element-33">
          <p className="text-2xl font-bold mb-6" data-id="element-34">
            We find a buyer willing to take it off your hands.
          </p>
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto" data-id="element-35">
            <circle cx="12" cy="8" r="4" stroke="#E11D48" strokeWidth="1.5" data-id="element-36" />
            <path d="M5 18C5 15.7909 7.01472 14 9.5 14H14.5C16.9853 14 19 15.7909 19 18" stroke="#E11D48" strokeWidth="1.5" data-id="element-37" />
          </svg>
        </div>
  }, {
    id: 3,
    content: <div className="flex items-center justify-center space-x-8" data-id="element-38">
          <div className="text-center" data-id="element-39">
            <p className="text-xl font-bold mb-2" data-id="element-40">Owner</p>
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-41">
              <circle cx="12" cy="8" r="4" stroke="white" strokeWidth="1.5" data-id="element-42" />
              <path d="M5 18C5 15.7909 7.01472 14 9.5 14H14.5C16.9853 14 19 15.7909 19 18" stroke="white" strokeWidth="1.5" data-id="element-43" />
            </svg>
          </div>
          <motion.div animate={{
        x: [0, 20, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        repeatType: 'reverse'
      }} data-id="element-44">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-45">
              <path d="M5 12H19" stroke="#E11D48" strokeWidth="2" strokeLinecap="round" data-id="element-46" />
              <path d="M12 5L19 12L12 19" stroke="#E11D48" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-47" />
            </svg>
          </motion.div>
          <div className="text-center" data-id="element-48">
            <p className="text-xl font-bold mb-2" data-id="element-49">Buyer</p>
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-50">
              <circle cx="12" cy="8" r="4" stroke="#E11D48" strokeWidth="1.5" data-id="element-51" />
              <path d="M5 18C5 15.7909 7.01472 14 9.5 14H14.5C16.9853 14 19 15.7909 19 18" stroke="#E11D48" strokeWidth="1.5" data-id="element-52" />
            </svg>
          </div>
        </div>
  }, {
    id: 4,
    content: <div className="text-center" data-id="element-53">
          <p className="text-3xl font-bold" data-id="element-54">
            You walk away. They take control.
          </p>
          <svg width="100" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto mt-6" data-id="element-55">
            <path d="M9 11L12 14L22 4" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-56" />
            <path d="M21 12V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H16" stroke="white" strokeWidth="1.5" data-id="element-57" />
          </svg>
        </div>
  }, {
    id: 5,
    content: <div className="text-center" data-id="element-58">
          <p className="text-3xl font-bold text-red-600 mb-6" data-id="element-59">
            Message us today.
          </p>
          <div className="flex flex-wrap justify-center gap-3" data-id="element-60">
            <div className="bg-white text-black px-4 py-2 rounded font-medium" data-id="element-61">
              WhatsApp
            </div>
            <div className="bg-white text-black px-4 py-2 rounded font-medium" data-id="element-62">
              Telegram
            </div>
            <div className="bg-white text-black px-4 py-2 rounded font-medium" data-id="element-63">
              Email
            </div>
          </div>
        </div>
  }];
  return <div ref={containerRef} className="w-full max-w-2xl mx-auto bg-black rounded-lg overflow-hidden aspect-video" data-id="element-64">
      <div className="relative w-full h-full flex items-center justify-center p-8" data-id="element-65">
        <AnimatePresence mode="wait" data-id="element-66">
          <motion.div key={currentScene} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.5
        }} className="text-white text-center w-full" data-id="element-67">
            {scenes[currentScene].content}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>;
};